export default __webpack_public_path__ + "static/media/image30tum.b0ebace6.jpg";